import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=b7233a1a&scoped=true"
import script from "./DataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=b7233a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7233a1a",
  null
  
)

export default component.exports